exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.reviewContainer[data-v-1d1adab6] {\n  display: inline-block;\n  float: none;\n  vertical-align: top;\n}\n.stars[data-v-1d1adab6] {\n  color: #FFBB33;\n  display: inline-block;\n  padding-left: 1em;\n  letter-spacing: 3px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d1adab6","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Activity/ActivityReviews.vue
// module id = 631
// module chunks = 3